import { render, staticRenderFns } from "./WeekStar.vue?vue&type=template&id=5e39286a&scoped=true"
import script from "./WeekStar.vue?vue&type=script&lang=js"
export * from "./WeekStar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e39286a",
  null
  
)

export default component.exports